import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { NavLink } from 'react-router-dom'
import { Panel, FormControl, Button, Glyphicon } from 'react-bootstrap'

import getServerURL from '../../../functions/getServerURL'


class RequestPasswordReset extends Component {

  state = {
    userIdentifier: '',
    sendingPassworedResetRequest: false,
    errorMessage: '',
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  sendPasswordResetRequest = () => {
    if (this.state.sendingPassworedResetRequest) {
      return
    }

    if (!this.state.userIdentifier) {
      return this.setState({ errorMessage: 'Please enter a username or email address.' })
    }

    this.setState({ sendingPassworedResetRequest: true, errorMessage: '' })

    axios({
      method: "POST",
      url: `${getServerURL()}request-recover-password/`,
      data: { user_identifier: this.state.userIdentifier },
    })
    .then((response) => {
      this.setState({ sendingPassworedResetRequest: false })
      return swal({
        title: "Email sent",
        text: "An email with instructions for resetting your password has been sent to the email address associated with the requested user account.",
        icon: "success",
        button: "Continue",
      })
      .then(() => this.props.routerProps.history.push('/'))
    })
    .catch(error => {
      let errorMessage
      if (error && error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      } else if (error && error.response && error.response.status === 500) {
        errorMessage = "The server is down."
      } else {
        errorMessage = "There was an error processing your request. Please try again."
      }

      this.setState({
        sendingPassworedResetRequest: false,
         errorMessage,
      })
    })
  }

  render() {
    return (
      <div id="ResetPassword" className='login-body'>
        <Panel id="ResetPasswordPanel" className="animated fadeInDown">
          <Panel.Body>

            <span>
              Enter your username or the email address. Instructions for resetting your password will be sent to the email address associated with your account.
            </span>

            <br/>
            <br/>
            {this.state.errorMessage ?
              <span className='required'>
              {this.state.errorMessage}
              </span>
              :
              null
            }
            <br/>

            <FormControl
              name="userIdentifier"
              value={this.state.userIdentifier}
              onChange={this.handleChange}
              placeholder="Username or email"
            >
            </FormControl>

            <br/>
            <br/>

            <Button
              bsStyle='primary'
              onClick={this.sendPasswordResetRequest}
            >
              {this.state.sendingPassworedResetRequest ?
                <Glyphicon glyph='refresh' className='rotate'/>
                :
                'Request password reset'
              }
            </Button>

            <br/>
            <br/>

            <NavLink to='/'>
              Back to login
            </NavLink>

          </Panel.Body>
        </Panel>
      </div>
    )
  }
}

export default connect()(RequestPasswordReset)



// WEBPACK FOOTER //
// ./src/routes/login/components/RequestPasswordReset.js